import type { ISerialize } from '@/objects/ISerialize';

export class ResetPasswordRequest implements ISerialize {
    public Code: string | null;

    public ConfirmPassword: string | null;

    public Language: string | null;

    public Password: string | null;

    public Username: string | null;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {
        Code?: string | null;
        ConfirmPassword?: string | null;
        Language?: string | null;
        Password?: string | null;
        Username?: string | null;
    }) {
        this.Code = values.Code ?? null;

        this.ConfirmPassword = values.ConfirmPassword ?? null;

        this.Language = values.Language ?? null;

        this.Password = values.Password ?? null;

        this.Username = values.Username ?? null;
    }

    public serialize(): string {
        return (
            '{' +
            `"Code": ${JSON.stringify(this.Code)}` +
            ',' +
            `"ConfirmPassword": ${JSON.stringify(this.ConfirmPassword)}` +
            ',' +
            `"Language": ${JSON.stringify(this.Language)}` +
            ',' +
            `"Password": ${JSON.stringify(this.Password)}` +
            ',' +
            `"Username": ${JSON.stringify(this.Username)}` +
            '}'
        );
    }

    /**
     * Creates an instance of ResetPasswordRequest from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        Code?: string | null;
        ConfirmPassword?: string | null;
        Language?: string | null;
        Password?: string | null;
        Username?: string | null;
    }): ResetPasswordRequest {
        return new ResetPasswordRequest(values);
    }

    public static _FromServerJson(json: any): ResetPasswordRequest {
        return new ResetPasswordRequest({
            Code: json.Code ?? '',
            ConfirmPassword: json.ConfirmPassword ?? '',
            Language: json.Language ?? '',
            Password: json.Password ?? '',
            Username: json.Username ?? '',
        });
    }

    /**
     * Creates an instance of ResetPasswordRequest from another instance of ResetPasswordRequest.
     * @param other The ResetPasswordRequest you want to clone
     * @returns A cloned ResetPasswordRequest
     */
    public static FromOther(other: ResetPasswordRequest): ResetPasswordRequest {
        return ResetPasswordRequest._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return ResetPasswordRequest.FromOther(this);
    }

    static NAME_OF_CLASS = 'ResetPasswordRequest';
}
